import AnalyticsHigherLevels from './AnalyticsHigherLevels';

export default AnalyticsHigherLevels;